import { Box, styled } from '@mui/material';

export const Section = styled('section')(({ theme }) => (props) => ({
    padding: '24px 48px',
    margin: '0px 0',
    border: '1px solid #00000014 ',
    minHeight: '120vh',
    background: theme.palette.mode === "light" ?
        theme.palette.background.lightSecondary : theme.palette.background.darkSecondary,
    borderRadius: theme.palette.bigBorderRadios,
    [theme.breakpoints.down('md')]: {
        padding: '12px',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '6px',
    },
    transition: "0.3s all fade"
}))
export const Card = styled(Box)(({ theme }) => (props) => ({
    boxSizing: 'border-box',
    minHeight: '165px',
    height: '165px',
    width: '600px',
    boxShadow: '0px 1px 12px 0px #00000014',
    padding: '8px 24px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    margin: '16px 0',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        height: 'auto',
        width: '100%'
    }
}));

export const CardImg = styled(Box)(({ theme }) => (props) => ({
    width: '100px',
    height: '120px',
    padding: '16px 24px',
}));

export const Img = styled('img')(({ theme }) => (props) => ({
    width: '100%',
    height: '100%',
}));

export const CardContent = styled(Box)(({ theme }) => (props) => ({
    flexDirection: 'column',
    gap: '16px',
    flex: 1
}));
export const TextCard = styled(Box)(({ theme }) => (props) => ({
    flexDirection: 'column',
    gap: '8px'
}));
export const TitleCard = styled('h3')(({ theme }) => (props) => ({
    fontWeight: '500px',
    fontSize: '18px',
    color: '#000',
    margin: '0'
}));

export const DiscCard = styled('p')(({ theme }) => (props) => ({
    fontWeight: '400px',
    fontSize: '16px',
    color: '#333333CC',
    minHeight: '40px',
    maxHeight: '40px',

}));
export const SectionRate = styled('div')(({ theme }) => (props) => ({
    display: "Flex",
    alignItems: 'center',
    gap: '8px',
    marginTop: '16px',
    justifyContent: 'right',
    width: '100%'
}))
export const TitleDisc = styled('p')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0em',
    width: '100%',
    textAlign: 'left',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    margin: '0',
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
        lineHeight: '1.5',
    },
}))




